import React from 'react';
import Reflux from 'reflux';
import { Panel, Row, Col } from 'bootstrap';
import EventPhotoSelector from 'shared/components/event/eventPhotoSelector.jsx';
import role from 'shared/lib/role';
import s3 from 'shared/constants/s3';
import TeamTabIdConstants from 'shared/constants/TeamTabIdConstants';
import RouteActions from 'flux/actions/RouteActions';
import TeamViewStore from 'flux/stores/TeamViewStore';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventViewStore from 'flux/stores/EventViewStore';
import EventActions from 'flux/actions/EventActions';
import EventDateRange from 'main/components/event/dateRange';

/**
 * Team Header
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(EventViewStore, 'event'),
  ],

  contextTypes: {
    user: React.PropTypes.object.isRequired,
  },

  displayName: 'EventHeader',

  getDefaultProps() {
    return {
      actionButton: null,
    };
  },

  render() {
    let eventState = this.state.event,
      teamState = this.state.team;

    let columnBtnClasses = 'hidden-xs';
    let { actionButton } = this.props;

    if (!actionButton) columnBtnClasses += ' hidden';

    let teamId = teamState.get('_id'),
      eventId = eventState.get('_id');

    if (!eventState) return <div />;

    return (
      <div className="event-dash-header-row">
        <Panel className="panel-page-header">
          <Row className="row-page-header-bottom">
            <Col
              lg={11}
              lgOffset={0}
              md={11}
              sm={11}
              mdOffset={0}
              smOffset={0}
              className="hidden-xs"
            >
              <h3 className="header-title">{eventState.get('title')}</h3>
              <p className="header-subtitle-label">
                <EventDateRange event={eventState} />
              </p>
            </Col>
            <div className="hidden-lg hidden-md hidden-sm text-center">
              <h3 className="header-title">{eventState.get('title')}</h3>
            </div>
            <Col
              className="event-header-avatar-wrapper hidden-xs"
              lg={11}
              md={9}
              sm={9}
            >
              <EventPhotoSelector
                teamId={teamId}
                eventId={eventId}
                imgUri={eventState.get('photo')}
                handlePhotoChange={(e) =>
                  this._handleEventPhotoChange(e, teamId, eventId)
                }
                displayPhotoSelector
              />
            </Col>
            <Col
              className={columnBtnClasses}
              lgOffset={4}
              lg={1}
              mdOffset={4}
              md={1}
              smOffset={4}
              sm={1}
            >
              {this.props.actionButton || null}
            </Col>
            <Col
              className="hidden-xs event-header-avatar-wrapper"
              lg={2}
              md={4}
              sm={4}
            >
              {this._getTeamAvatarNode()}
            </Col>
          </Row>
        </Panel>
      </div>
    );
  },

  _getTeamAvatarNode() {
    let teamState = this.state.team;
    let teamId = teamState.get('_id'),
      teamPhoto = teamState.get('photo');

    if (!teamPhoto) {
      teamPhoto = s3.defaulTeamPhoto;
    }

    if (!role.hasTeamAdminRole(this.context.user, teamId)) {
      return (
        <div className="team-photo-upload">
          <img src={teamPhoto} alt="team avatar" />
        </div>
      );
    } else {
      return (
        <div className="team-photo-upload">
          <a
            onClick={(e) => {
              e.preventDefault();
              RouteActions.goToTeamDash({
                teamId,
                tabId: TeamTabIdConstants.UpcomingEvents,
              });
            }}
          >
            <img src={teamPhoto} alt="team avatar" />
          </a>
        </div>
      );
    }
  },

  _handleEventPhotoChange(e, teamId, eventId) {
    var file = e.target.files[0];

    if (!file) return;

    EventActions.updatePhoto(teamId, eventId, file);
  },

  _handleTeamPhotoChange(e, teamId) {
    var file = e.target.files[0];

    if (!file) return;

    TeamViewActions.savePhoto(file, teamId);
  },
});
